<template>
  <v-container fluid class="user-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="e1" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="e1 > 1" step="1">Create Account</v-stepper-step>

              <v-divider></v-divider>
              <v-stepper-step :complete="e1 > 2" step="2">Rental Details</v-stepper-step>
              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="3">User Details</v-stepper-step>

            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Account</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Name']"
                          outlined
                          dense
                          placeholder="Name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Phone Number']"
                          outlined
                          dense
                          placeholder="Phone Number">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Email']"
                          outlined
                          dense
                          placeholder="Email Address">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Password']"
                          outlined
                          dense
                          placeholder="Password"
                          persistent-hint
                          single-line hint="Enter your password. Min 6 characters long">
                        </v-text-field>
                        <div class="d-flex justify-end">
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="e1 = 2">
                            Next
                          </v-btn>
                        </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Vacation Rental Account</p>
                        <p>If you already have accounts to use, please enter them below</p>
                        <p class="text-h6">AirBnB info:</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Airbnb Email']"
                          outlined
                          dense
                          placeholder="Airbnb Email">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Airbnb Password']"
                          outlined
                          dense
                          placeholder="Airbnb Password">
                        </v-text-field>
                        <p class="text-h6">VRBO Info:</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user['VRBO Email']"
                          outlined
                          dense
                          placeholder="VRBO Email">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['VRBO Password']"
                          outlined
                          dense
                          placeholder="VRBO Password">
                        </v-text-field>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="e1 = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="e1 = 3"
                          >
                            Next
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Owner Details</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Shipping Address']"
                          outlined
                          dense
                          placeholder="Mailing Address">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Birthday']"
                          outlined
                          dense
                          placeholder="Birthday (MM/DD/YYYY)">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Routing Number']"
                          outlined
                          dense
                          placeholder="Bank Routing Number"
                          persistent-hint
                          single-line hint="Will be used for rental payouts and fees">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user['Account Number']"
                          outlined
                          dense
                          placeholder="Bank Account Number"
                          persistent-hint
                          single-line hint="Will be used for rental payouts and fees">
                        </v-text-field>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="e1 = 2"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createUser()">
                            Finish
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      e1: 1,
      user: {
        'Name': '',
        'Phone Number': '',
        'Email': '',
        'Password': '',
        'Role': 'Owner',
        'Airbnb Email': '',
        'Airbnb Password': '',
        'VRBO Password': '',
        'VRBO Email': '',
        'Shipping Address': '',
        'Birthday': '',
        'Routing Number': '',
        'Account Number': '',
      },
    }
  },

  methods: {
    ...mapActions('people', [
      'createUserRequest',
      'getUsersRequest'
    ]),
    createUser() {
      this.createUserRequest(this.user)
      this.getUsersRequest()
      router.push('/people/owners')
    }
  },
  computed: {
    ...mapState('usersList', ['isReceiving'])
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
